import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const GeneralRules = () => {
  useEffect(() => {
    document.title = 'General Rules -  Sacred Heart School, Ballia - U.P.';  
}, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>General Rules</h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>About</li>
                            <li>|</li>
                            <li> General Rules  </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
                 <div className='container'>
                    <div className='row'>
                    <div class="col-md-12"> 
    	<div class="media">
          <div class="media-body">
            <p><strong>1.</strong> All students should be present in school on the opening day of each term.</p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>2.</strong>  Irregular attendance, unjustified absence or objectionable moral behaviour justify dismissal. If a student is absent for fifteen consecutive days without an application, or for three days at the beginning of a term, his/her name may be struck off the rolls.The school demands 90% attendance.</p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>3.</strong> No books other than the text books, may be brought to school. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>4.</strong> Students are strictly forbidden to bring any articles (eg. slam books, albums , camera , C.D. , mobiles and other electronic devices)/ books/magazines to school other than study materials. Such violation will be dealt severely. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>5.</strong> No student should leave the school premises during class hours without the knowledge and permission of the Principal. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>6.</strong> Any damage to the school property will have to be made good. The decision of the Principal regarding the amount is final. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>7.</strong> The school is not responsible for goods lost. students should not carry or wear valuable articles when coming to school.</p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>8.</strong> No student suffering from a contagious or infectious disease will be permitted to school. After recovery a medical certificate is to be submitted. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>9.</strong> During school hours, students are not allowed to receive visitors or make phone calls or to answer a phone call. If the matter is very urgent, the message will be given.</p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>10.</strong> Any student desiring to be exempted from P.T. or games must produce a doctor's certificate to the effect the he/she is physically unfit to take part. </p>
          </div>
        </div> 
    	<div class="media">
          <div class="media-body">
            <p><strong>11.</strong> All students should be habitually clean and always neatly dressed.They areexpected to come in uniform everyday. They should keep their nails short and clean. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>12.</strong> The boys are expected not to keep long hair.The girls are expected to use black hair band (if the hair is short) or black ribbon if the hair is long. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>13.</strong> Attending the school with hair dyes, sprays, nail polish, friendship bands etc is discouraged. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>14.</strong> Students must come to class with the lessons well prepared and the homework completed. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>15.</strong> The school prospectus should be brought to the school daily. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>16.</strong> Running, playing and shouting inside the school building is never allowed. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>17.</strong> When students move along the verandahs to other class rooms, they must walk in silence and in single line. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>18.</strong> Students should be particularly careful not to throw paper or fruit peels any where in the school premises.They should use bins especially provided for that purpose.</p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>19.</strong> No student should remain in the classroom during P.T. or games period unless permitted by the Principal. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>20.</strong> Students are responsible to the school authorities not only for their conduct in school but also for their general behaviour outside.Any reported or observed objectionable conduct out of school shall make them liable to disciplinary action.</p>
          </div>
        </div> 
    	<div class="media">
          <div class="media-body">
            <p><strong>21.</strong> Students are not allowed to enter a classroom other than their own. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>22.</strong> Articles found in the school or its premises are to be handed over to the office. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>23.</strong> Disobedience and misbehaviour towards staff members or repeated breaking of school rules or behaviour objectionable to the good tone of school will deserve disciplinary action even dismissal if warnings are ignored. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>24.</strong> Unit tests, assignments and terminal exams are obligatory on all students. No one should absent oneself for an examination/test. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>25.</strong> If a student is absent for a test or examination re-test or re-examination will not be given. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>26.</strong> Parents send their children to this school so that they may be proficient in both Hindi and English. In the school premises all are expected to speak only in English. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>27.</strong> Students should at all cost should avoid writing, carving, and scratching on walls and furniture. Such habits are detrimental to good education and a sign of low taste. </p>
          </div>
        </div>
    	<div class="media">
          <div class="media-body">
            <p><strong>28.</strong> Principal's permission is required: </p>
            <ul className="list schoolfee">
            	<li>to make collection for any purpose whatsoever,</li>
            	<li>to arrange for a party, picnic or meeting,</li>
            	<li>to join a sports meet or to play a game not arranged by school, </li>
            	<li>to give presents to teachers or state displays in their honour and </li>
            	<li>to arrange for private tuitions from the school teachers. </li>
            </ul>
          </div>
        </div>
    </div>
                    </div>
                 </div>
             </section>
            <Footer/>
        </>
    )
}

export default GeneralRules